import { useMemo } from "react";

export interface SalesforceSourceSettingsText {
  unauthorisedWarningText: string;
  dataToLoadLabelText: string;
  dataToLoadPlaceholderText: string;
  dataToLoadHintText: string;
  statusFieldLabelText: string;
  statusFieldPlaceholderText: string;
  statusFieldHintText: string;
  noStatusFieldsAvailableText: string;
  statusesToLoadLabelText: string;
  statusesToLoadPlaceholderText: string;
  statusesToLoadHintText: string;
  doneStatusLabelText: string;
  doneStatusPlaceholderText: string;
  doneStatusHintText: string;
  dueDateFieldLabelText: string;
  dueDateFieldPlaceholderText: string;
  dueDateFieldHintText: string;
  assignedToMeLabelText: string;
  assignedToMeHintText: string;
  loadingText: string;
  loadErrorText: string;
}

export const useSalesforceSourceSettingsText = (
  t: (key: string) => string,
): SalesforceSourceSettingsText => {
  return useMemo(() => {
    const tKey = (key: string): string =>
      t(`board.connections.dialog.sourceSettings.salesforce.${key}`);

    return {
      unauthorisedWarningText: tKey("unauthorisedWarning"),
      dataToLoadLabelText: tKey("dataToLoadLabel"),
      dataToLoadPlaceholderText: tKey("dataToLoadPlaceholder"),
      dataToLoadHintText: tKey("dataToLoadHint"),
      statusFieldLabelText: tKey("statusFieldLabel"),
      statusFieldPlaceholderText: tKey("statusFieldPlaceholder"),
      statusFieldHintText: tKey("statusFieldHint"),
      noStatusFieldsAvailableText: tKey("noStatusFieldsAvailable"),
      statusesToLoadLabelText: tKey("statusesToLoadLabel"),
      statusesToLoadPlaceholderText: tKey("statusesToLoadPlaceholder"),
      statusesToLoadHintText: tKey("statusesToLoadHint"),
      doneStatusLabelText: tKey("doneStatusLabel"),
      doneStatusPlaceholderText: tKey("doneStatusPlaceholder"),
      doneStatusHintText: tKey("doneStatusHint"),
      dueDateFieldLabelText: tKey("dueDateFieldLabel"),
      dueDateFieldPlaceholderText: tKey("dueDateFieldPlaceholder"),
      dueDateFieldHintText: tKey("dueDateFieldHint"),
      assignedToMeLabelText: tKey("assignedToMeLabel"),
      assignedToMeHintText: tKey("assignedToMeHint"),
      loadingText: tKey("loading"),
      loadErrorText: tKey("loadError"),
    };
  }, [t]);
};
